import { VariableType } from 'json-to-graphql-query';
export const StateFilterVariables = { filters: 'StateFilters' };
export const FilterVariables = { filters: 'FiltersInput' };
export const FilterArgs = { filters: new VariableType('filters') };
//# sourceMappingURL=filters.js.map